import {AbstractAsset} from '../abstract-asset';

export class AssetResource {
  asset: AbstractAsset;
  selectedValue: number;
}
